import { render } from "./Home.vue?vue&type=template&id=fae5bece"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fae5bece"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fae5bece', __exports__)) {
    console.log('reload')
    api.reload('fae5bece', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=fae5bece", () => {
    console.log('re-render')
    api.rerender('fae5bece', render)
  })

}


export default __exports__